import {
    AppStats,
    CmsTokenObject,
    CreateCmsToken, GetUsersAnalyticsReturn as UserSeries,
    SearchAppsReturn
} from "api";
import { UploadedImagesMap } from "components/AppImageUploader";
import { ClientApp, ClientAppSummary } from "models";


export { AppStats };

interface AppMap<T> {
    [appId: string]: T;
}

/**
 * A page of the apps.  The `lastEvaluatedKey` is the last intent that
 * was processed. If this exists, then that means there are more pages that can be
 * queried.  The reducer will put the pages in order as they come unless signaled to
 * reset.
 */
export type AppPage = {
    apps: ClientAppSummary[];
    lastEvaluatedKey?: string;
};

/**
 * A map that maps the apps to the organization with which they are placed.
 */
export type AppsMap = {
    [organizationId: string]: ClientAppSummary[];
};

/**
 * A map that maps the app pages to the organization with which they are placed.
 */
export type AppPagesMap = {
    [organizationId: string]: AppPage[];
};

/**
 * This is the object of a series.  It contains the date and stats of user analytics.
 */
export interface UserAnalyticsTime {
    isoDate: string;
    apps: AppStats;
}

/**
 * A map that matches the error with the action that was performed.  This is if there was
 * an error from the last time the action was performed otherwise there is no error present.
 */
export type ErrorMap = {
    [action: string]: Error;
};

export type Tokens = {
    currentTokens?: CmsTokenObject[];
    newToken?: CreateCmsToken;
};

export type AppState = {
    appPagesMap: AppPagesMap;
    appsMap: AppsMap; // todo: remove
    currentApp?: ClientApp;
    errorMap: ErrorMap;
    exportContent?: string;
    tokens?: AppMap<Tokens>;
    searchAppsResult: SearchAppsReturn;
    uploadedImages?: UploadedImagesMap;
    userAnalytics: AppMap<UserSeries>;
};
